export default __webpack_public_path__ + "static/media/icons8-github.7d909b64.gif";